<template>
    <main>
        <div>
            <div class="card text-center" style="padding: 10px 5% 10px;">
                <div class="card-body">                                
                    <p class="colLetra" style="font-weight: 700; font-size: 25px;" :class="'card-title'">INICIA SESIÓN YA!</p>
                    <v-form ref="form" v-model="validdata" lazy-validation @submit.prevent="validate">
                        <div class="row">                                        
                            <div style="padding: 5px;" class="col-lg-12">
                            <v-text-field
                                    v-model="loginuser.datauser"
                                    placeholder="Escriba su Nombre de Usuario o Email"
                                    single-line
                                    :rules="[rules.required,rules.space]"
                                    outlined
                                ></v-text-field>
                                <v-layout v-if="userexist">
                                    <label class ="fas fa-exclamation-triangle">Usuario no Registrado, por favor Registrese</label>
                                </v-layout> 
                            </div>
                            <div style="padding: 5px;" class="col-lg-12">
                                <v-text-field
                                    v-model="loginuser.password"
                                    :append-icon="showpassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
                                    :rules="[rules.required, rules.min]"
                                    :type="!showpassword ? 'text' : 'password'"
                                    name="input-10-1"
                                    placeholder="Escriba su contraseña"
                                    @click:append="showpassword = !showpassword"
                                ></v-text-field>
                                <v-layout v-if="incorrectpassword">
                                    <label class ="fas fa-exclamation-triangle"> Contraseña Incorrecta</label>
                                </v-layout> 
                            </div>
                        </div>
                        
                        <div>
                            <button type="submit" class="btn btn-lg" style="background:#11679a;color:white">INICIAR SESIÓN</button>
                        </div>
                        <div  style="padding-top: 10px;">
                            <p class="colLetra" @click="opendialogforgetpassword" style="cursor:pointer">¿Has olvidado tu contraseña?</p>
                        </div>
                        <div>
                            <span class="colLetra">
                                o inicia sesión con
                            </span>
                        </div>
                        
                        <div class="form-inline row" v-if="false">
                            <div class="col-sm-4 icono">
                                <i @click="LoginwithFacebook" class="i fab fa-facebook-f"></i>
                            </div>
                            <div class="col-sm-4 icono">
                                <i @click="LoginwithTwitter" class="i fab fa-twitter"></i>
                            </div>
                            <div class="col-sm-4 icono">
                                <i @click="LoginwithGoogle" class="i fab fa-google"></i>
                            </div>
                        </div>
                        <p class="colLetra">¿Todavia no tienes una cuenta?
                            <a style="text-decoration: underline blue" @click="goRegister">Registrate aqui</a>
                        </p>
                    </v-form>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import LoginUser from '@/models/loginuser'
import { EventBus } from '@/helpers/eventbus/event-bus'
import config from '@/config/env.example'
import {RoutesStorage} from '@/helpers/storage'
export default {
    data(){
        return{
            userexist: false,
            incorrectpassword: false,
            validdata: true,
            showpassword: true,
            loginuser: new LoginUser(),
            routesStorage:new RoutesStorage(),
            rules: {
                required: value => !!value || 'Requerido',
                min: v => v.length >= 8 || 'Minimo 8 caracteres',
                emailMatch: () => ('The email and password you entered don\'t match'),
                space: value =>{
                    const pattern = /\s/
                    return !pattern.test(value) || 'No dejes espacios en blanco'
                }
            },
        }
    },
    methods:{
        opendialogforgetpassword(){
          EventBus.$emit('opendialogforgetpassword')
        },
        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        saveIdentity() {
            this.$store.dispatch('saveIdentity', this.identity)
            localStorage.setItem('iden', JSON.stringify(this.identity))
            this.$store.dispatch('saveToken', this.token)
            localStorage.setItem('tok', this.token)
        },
        LoginwithFacebook(){
          //renderauthsocialnetwork.rendersocialnetwork = true
          window.location = `${config.host}auth/facebook`
        },

        LoginwithGoogle(){
          //renderauthsocialnetwork.rendersocialnetwork = true
          window.location = `${config.host}auth/google`
        },

        LoginwithTwitter(){
          //renderauthsocialnetwork.rendersocialnetwork = true
          window.location = `${config.host}auth/twitter`
        },
        goRegister(){
            this.$emit('activeRegister',1)
        },
        validate () {
          if (this.$refs.form.validate()) {
            this.snackbar = true
            //this.loginuser.dni = this.loginuser.dni
            this.loginuser.gettoken = true
            this.axios.post('users/loginuser',this.loginuser)
                /******************* * Login Exitoso!!!!******************************* */
                .then((res) => {
                  //console.log(res)
                    let msg = res.data.message
                    this.identity = res.data.user
                    this.token = res.data.token
                    //console.log(this.identity)
                    //console.log(this.token)

                    this.$emit('close')
                    this.saveIdentity()
                    this.$socket.emit('join:room', this.identity._id)
                    setTimeout(() => {
                        //this.activeSocket()
                        //this.$router.push('/home');
                        // window.location =  window.location.href 
                        window.location  =  this.routesStorage.get()?this.routesStorage.get().login:window.location.href||window.location.href 
                    }, 400)
                    //this.getidentity()
                    //this.getuserforLocalStorage()
                })
                /******************* * Login Errado!!!!********************************/
                .catch((err) => {
                    let msg = err.response.data.message

                    if (msg === "Usuario no Registrado, porfavor Registrese") {
                        this.userexist = true
                        document.getElementById('datauser').focus()
                        setTimeout(() => {
                            this.userexist = false
                        }, 5000)
                    }

                    if (msg === "La Contraseña es incorrecta, intentelo de nuevo") {
                        this.incorrectpassword = true
                        document.getElementById('password').focus()
                        setTimeout(() => {
                            this.incorrectpassword = false
                        }, 5000)
                    }

                    if(msg === 'Todos los campos son necesarios'){
                      alertify.error(msg)
                    }
                })
            }
        },
    }

}
</script>